$('.m-list-unidades .label').click(function (event) {
	$(this).parent().toggleClass('is-active');
	$('button i', this).toggleClass('fa-chevron-circle-down fa-chevron-circle-up');
	CNET.FooterCheck();
});

Pesquisa = {
	items: [],
	init: function () {
		Pesquisa.items = [];

		$('.m-list-unidades ul li ul li a').each(function (key, val) {
			var h = $(this).attr('href');
			var n = $('.name', this).text();
			var titleP = $(this).parent().parent().parent();
			var t = $('.title', titleP).text();

			Pesquisa.items.push({ "href": h, "name": n, "father": t });
		});
	},
	resetChr: function (text) {
		var chrEspeciais = new Array("á", "à", "â", "ã", "ä", "é", "è", "ê", "ë",
			"í", "ì", "î", "ï", "ó", "ò", "ô", "õ", "ö",
			"ú", "ù", "û", "ü", "ç",
			"Á", "À", "Â", "Ã", "Ä", "É", "È", "Ê", "Ë",
			"Í", "Ì", "Î", "Ï", "Ó", "Ò", "Ô", "Õ", "Ö",
			"Ú", "Ù", "Û", "Ü", "Ç");
		var chrNormais = new Array("a", "a", "a", "a", "a", "e", "e", "e", "e",
			"i", "i", "i", "i", "o", "o", "o", "o", "o",
			"u", "u", "u", "u", "c",
			"A", "A", "A", "A", "A", "E", "E", "E", "E",
			"I", "I", "I", "I", "O", "O", "O", "O", "O",
			"U", "U", "U", "U", "C");
		for (index in chrEspeciais) {
			text = text.replace(chrEspeciais[index], chrNormais[index]);
		}

		return text.toLowerCase();
		CNET.FooterCheck();
	},
	reset: function () {
		$('.m-busca-lista .result').removeClass('is-active');
		$('.m-busca-lista .result ul').html("");
		$('.m-busca-lista input').val("");
		$('.m-list-unidades').addClass('is-active');
		$('.m-busca-lista .result .release .qtd').text("0");
		CNET.FooterCheck();
	},
	search: function (terms, reset) {
		result = [];
		reset = reset || false;
		terms = Pesquisa.resetChr(terms);
		allResults = terms == "*" ? true : false;

		if (terms.length == 0 && reset) {
			Pesquisa.reset();
			return false;
		}

		if (allResults) {

			allResults = true;

			$.each(Pesquisa.items, function (key, val) {
				var t = val.name;
				t = Pesquisa.resetChr(t);
				result.push(key);
			});
		}

		else {
			$.each(Pesquisa.items, function (key, val) {

				var t = val.name;
				t = Pesquisa.resetChr(t);
				var p = t.search(terms);
				if (p > -1) {
					result.push(key);
				}
			});
		}

		$('.m-busca-lista .result').addClass('is-active');
		$('.m-busca-lista .result ul').html("");
		$('.m-list-unidades').removeClass('is-active');
		$('.m-busca-lista .result .release .qtd').text(result.length);

		if (result.length !== 0) {
			$.each(result, function (key, val) {
				$('.m-busca-lista .result ul').append("<li><a href=\"" + Pesquisa.items[val].href + "\"><span class=\"name\">" + Pesquisa.items[val].name + "</span><span class=\"title\">" + Pesquisa.items[val].father + "</span></a></li>");
			})
		}
		CNET.FooterCheck();
	}
}


if ($('.m-list-unidades').length !== 0) {
	Pesquisa.init();
}

$('.m-busca-lista input').on('focus keyup', function (e) {
	if (e.type == 'focus' && window.innerWidth > 780) return;
	var terms = $(this).val();
	Pesquisa.search(terms, window.innerWidth > 780);
	CNET.FooterCheck();
});

$('.m-busca-lista button, .m-busca-lista input').on('click', function (e) {

	if (e.type == 'focus' && window.innerWidth > 780) return;
	var terms = "*";
	Pesquisa.search(terms, window.innerWidth > 780);
	CNET.FooterCheck();
});

$('body').delegate('.m-busca-lista .btn-reset', 'touchstart touchmove touchend touchcancel click', function (event) {
	event.preventDefault();
	Pesquisa.reset();
	CNET.FooterCheck();
});

$('.m-busca-lista .campo input').on('focus', function () {
	if (window.innerWidth > 780) return;
	var input = $(this);
	$('html,body').animate({ scrollTop: input.offset().top - 20 }, 200);
	$('body').addClass('search-focus');
}).on('blur', function () {
	if (window.innerWidth > 780) return;
	$('body').removeClass('search-focus');
	var input = $(this);
	$('html,body').animate({ scrollTop: input.offset().top - 70 }, 200);
});

$('.page-content.home .valuations').owlCarousel({
	items: 1,
	loop: true,
	nav: false,
	dots: false,
	autoHeight: true,
	autoplay: true,
	responsive: {
		768: {
			items: 2,
			autoHeight: false,
		},
		1000: {
			items: 3,
		}
	}
});


$(window).on('resize init', function () {
	var full_banner = $('.page-content.home .full-banner');
	var parent = full_banner.closest('.container-12');
	if (window.innerWidth <= 780) {
		console.log(full_banner.closest('.container-12').is(':first-child'));
		if (parent.is(':first-child'))
			parent.appendTo($('.page-content.home .container-busca'))
	} else {
		if (!parent.is(':first-child'))
			parent.prependTo($('.page-content.home'))
	}
}).trigger('init');

/* smooth scroll */
// Select all links with hashes
$('a[href*="#"]')
	// Remove links that don't actually link to anything
	.not('[href="#"]')
	.not('[href="#0"]')
	.click(function (event) {
		// On-page links
		if (
			location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
			&&
			location.hostname == this.hostname
		) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1000, function () {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	});